import { BaseElement, defineElement } from "./lib-element-js.min.js";

class ImgLazyLoad extends BaseElement {
  image = this.querySelector("img");

  // lifecycle hook
  connected() {
    this.observe();
  }

  // reactive attributes/properties
  properties() {
    return {
      loaded: false,
    };
  }

  get cleanedSrcset() {
    const sizes = this.image.getAttribute("data-srcset").split("w,");
    let filteredSizes = sizes.filter((size) => {
      const width = size.split(" ")[1].replace("w", "");
      if (this.isRetina()) {
        return width <= this.image.offsetWidth * 2;
      }
      return width <= this.image.offsetWidth;
    });

    const combinedSizes = [...sizes];
    if (typeof filteredSizes.length + 2 !== "undefined") {
      combinedSizes.splice(filteredSizes.length + 2, 999999);
    } else if (typeof filteredSizes.length + 1 !== "undefined") {
      combinedSizes.splice(filteredSizes.length + 1, 999999);
    }

    return `${combinedSizes.join("w, ")}w`;
  }

  get lastSrcSetItem() {
    try {
      const sizes = this.image.getAttribute("data-srcset").split("w,");
      const lastItem = sizes[sizes.length - 1].split(" ")[0];
      return lastItem;
    } catch (err) {
      return false;
    }
  }

  isRetina() {
    var mediaQuery =
      "(-webkit-min-device-pixel-ratio: 1.5),\
        (min--moz-device-pixel-ratio: 1.5),\
        (-o-min-device-pixel-ratio: 3/2),\
        (min-resolution: 1.5dppx)";
    if (window.devicePixelRatio > 1) return true;
    if (window.matchMedia && window.matchMedia(mediaQuery).matches) return true;
    return false;
  }

  isInViewport() {
    const rect = this.image.getBoundingClientRect(),
      windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

    return !(
      Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) <
        1 ||
      Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < 1
    );
  }

  observe() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setSrcSet();
          }
        });
      },
      {
        rootMargin: "200px",
      }
    );
    observer.observe(this);
  }

  setSrcSet() {
    if (!this.loaded) {
      const newImage = new Image();
      newImage.addEventListener(
        "load",
        () => {
          this.image.src = this.lastSrcSetItem;
          this.loaded = false;
        },
        true
      );
      newImage.src = this.lastSrcSetItem;
    }
  }
}
defineElement("img-lazy-load", ImgLazyLoad);
